import React, { Component, Fragment } from "react";
import HomeChart from "../../../../../helper/homechart.helper";

class StyleExpoArea extends Component {
  componentDidMount() {
    this.renderAssetStylePieChart(this.props.res);
  }
  componentWillReceiveProps(nextProps) {
    let old_getBacktest = JSON.stringify(this.props.res);
    let new_getBacktest = JSON.stringify(nextProps.res);

    if (old_getBacktest !== new_getBacktest) {
      this.renderAssetStylePieChart(nextProps.res);
    }
  }

  renderAssetStylePieChart(data) {
    HomeChart.renderAssetStyleStockChart(
      "",
      "#asset_class_stock_place2",
      "",
      "",
      data
    );
  }

  render() {
    return (
      <Fragment>
        <div
          id="asset_class_stock_place2"
          style={{ width: "100%", height: "600px" }}
        />
      </Fragment>
    );
  }
}

export default StyleExpoArea;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/StyleExposure/styleExpoArea.jsx